import { Envelope } from "react-bootstrap-icons";

//App
import useIconStyles from "./styles";
import { IconProps } from "../../../types";

const ResendIcon = (props: IconProps) => {
  const { iconText = "Resend Verification", pendingText = "" } = props;
  const iconStyles = useIconStyles();
  return (
    <div style={iconStyles.flex}>
      <Envelope style={iconStyles.viewIcon} size={18} />
      <div style={iconStyles.iconText}>
        {iconText} {pendingText}
      </div>
    </div>
  );
};

export default ResendIcon;
